import { TerminalStatus } from '../types/terminal';
import type { TerminalRecordStatus } from '../types/terminal';

export const getTerminalStatusLabel = (
  status: TerminalRecordStatus,
  t: (key: string) => string,
): string => {
  const statusLabelMap: Record<TerminalRecordStatus, string> = {
    [TerminalStatus.AVAILABLE]: t('backoffice.terminalsListStatusAvailable'),
    [TerminalStatus.LINKED]: t('backoffice.terminalsListStatusLinked'),
    [TerminalStatus.ACTIVE]: t('backoffice.terminalsListStatusActive'),
    [TerminalStatus.INACTIVE]: t('backoffice.terminalsListStatusInactive'),
    [TerminalStatus.TEST]: t('backoffice.terminalsListStatusTest'),
    [TerminalStatus.SUPPORT]: t('backoffice.terminalsListStatusSupport')
  };

  return statusLabelMap[status] ?? status;
};
